module.exports = __webpack_public_path__ + "media/images/guide-6t-7eefc2e6f65d799b62736e986c059029.png";